// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"ToggleWidget_iconButton__2j8Z_"};